import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowDownToLine, ArrowUpToLine } from "lucide-react";

export const FlyerPreviewLarge = ({ open, onOpenChange, assetId, form, page = 0, strip = true }) => {
  const [img, setImg] = useState(null);
  const [err, setErr] = useState("");
  const scroller = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    let url = null;
    let cancelled = false;
    setImg(null); setErr("");
    api.post(`/marketing/assets/${assetId}/personalized/preview`, form, { params: { dpi: 150, page }, responseType: "blob" })
      .then((res) => { if (cancelled) return; url = URL.createObjectURL(res.data); setImg(url); })
      .catch(() => { if (!cancelled) setErr("Couldn't load the full-size preview."); });
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const jump = (bottom) => scroller.current?.scrollTo({ top: bottom ? scroller.current.scrollHeight : 0, behavior: "smooth" });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[96vw] max-h-[94vh] flex flex-col gap-3" data-testid="flyer-preview-large">
        <DialogHeader>
          <DialogTitle>Full-size preview</DialogTitle>
          <DialogDescription>Page {page + 1} at full size.{strip ? " Your contact strip is at the bottom of every page." : ""}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {strip && <Button size="sm" variant="outline" onClick={() => jump(true)} disabled={!img} data-testid="flyer-preview-jump-strip"><ArrowDownToLine className="w-4 h-4 mr-1.5" />Jump to contact strip</Button>}
          <Button size="sm" variant="ghost" onClick={() => jump(false)} disabled={!img} data-testid="flyer-preview-jump-top"><ArrowUpToLine className="w-4 h-4 mr-1.5" />Back to top</Button>
        </div>
        <div ref={scroller} className="flex-1 min-h-[300px] overflow-auto rounded-xl border border-border bg-white" data-testid="flyer-preview-large-scroll">
          {img ? <img src={img} alt="Full-size personalized flyer" className="block w-full min-w-[640px] h-auto" data-testid="flyer-preview-large-image" />
            : <div className="h-[300px] flex items-center justify-center text-sm text-slate-500">{err || <Loader2 className="w-6 h-6 animate-spin text-primary" />}</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
